import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { SocketServiceService } from '../../Service/Socket/socket-service.service';

import { environment } from '../../../environments/environment.prod';
const MINUTES_UNITL_AUTO_LOGOUT = 30 // in mins
const CHECK_INTERVAL = 1800000 // in ms
const STORE_KEY = 'lastAction';
@Injectable({
  providedIn: 'root'
})

export class CommonserviceService {
  serviceHost = environment.serviceHost;
  commanHost = environment.commanHost;
  sepHost = environment.sepHost;
  ProfileFile: any;
  userid: any = {}

  public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }
  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }
  public change: EventEmitter<any> = new EventEmitter();


  private FeesVal = new BehaviorSubject<string>('');
  Feesval = this.FeesVal.asObservable();

  private SiteInfo = new BehaviorSubject<string>('');
  Siteinfo = this.SiteInfo.asObservable();

  private ipaddress = new BehaviorSubject<any>('');
  Ipaddress = this.ipaddress.asObservable();


  UploadImg: any = {};
  ipdata: any;

  private GetTheme = new BehaviorSubject<string>('');
  getTheme = this.GetTheme.asObservable();

  private userImage = new BehaviorSubject<string>('');
  userHeaderImage = this.userImage.asObservable();
  constructor(private http: HttpClient, private router: Router, private socket: SocketServiceService) {
    this.userid = localStorage.getItem('userid')

    this.http.get<{ ip: string }>('https://api.ipify.org/?format=json').subscribe(data => {
      this.ipdata = data;
      const datas = {
        ipaddress: this.ipdata?.ip
      };
      localStorage.setItem('ip', this.ipdata?.ip)
    });
    this.check();
    this.initListener();
    this.initInterval();
    localStorage.setItem(STORE_KEY, Date.now().toString());
  }

  changeTheme(Values): any {
    this.GetTheme.next(Values);
  }

  postfunction(url, data): Observable<any> {
    const headers = new HttpHeaders().set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.post(this.serviceHost + url, data, { headers });
  }

  seppostfunction(url, data, token): Observable<any> {
    const headers = new HttpHeaders().set('authorization', token).set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.post(this.sepHost + url, data, { headers });
  }

  Postfunction(url, data, token): Observable<any> {
    const headers = new HttpHeaders().set('authorization', token).set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.post(this.serviceHost + url, data, { headers });
  }

  PostFunction(url, token): Observable<any> {
    const headers = new HttpHeaders().set('authorization', token).set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.post(this.serviceHost + url, { headers });
  }

  Getfunction(url, id): Observable<any> {
    const headers = new HttpHeaders().set('authorization', id).set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.get(this.serviceHost + url, { headers });
  }
  SepGetfunction(url, id): Observable<any> {
    const headers = new HttpHeaders().set('authorization', id).set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.get(this.sepHost + url, { headers });
  }
  getfunction(url): Observable<any> {
    const headers = new HttpHeaders().set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.get(`${this.serviceHost + url}`, { headers });
  }
  sepgetfunction(url): Observable<any> {
    const headers = new HttpHeaders().set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.get(`${this.sepHost + url}`, { headers });
  }
  getfunctionqwewqe(): Observable<any> {
    // const headers = new HttpHeaders().set('tag', 'web');
    return this.http.get(`https://api.wazirx.com/sapi/v1/tickers/24hr`);
  }

  putfunction(url, token, data): Observable<any> {
    const headers = new HttpHeaders().set('authorization', token).set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.put(this.serviceHost + url, data, { headers });
  }

  getTicker(): Observable<any> {
    return this.http.get(`https://api.wazirx.com/sapi/v1/tickers/24hr`);
  }
  mycall(url): Observable<any> {
    return this.http.get(url);
  }


  commanpostfunction(url, data): Observable<any> {
    const headers = new HttpHeaders().set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.post(this.commanHost + url, data, { headers });
  }

  commanPostfunction(url, data, token): Observable<any> {
    const headers = new HttpHeaders().set('authorization', token).set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.post(this.commanHost + url, data, { headers });
  }

  commanPostFunction(url, token): Observable<any> {
    const headers = new HttpHeaders().set('authorization', token).set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.post(this.commanHost + url, { headers });
  }

  commanGetfunction(url, id): Observable<any> {
    const headers = new HttpHeaders().set('authorization', id).set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.get(this.commanHost + url, { headers });
  }

  commangetfunction(url): Observable<any> {
    const headers = new HttpHeaders().set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.get(`${this.commanHost + url}`, { headers });
  }

  commanputfunction(url, token, data): Observable<any> {
    const headers = new HttpHeaders().set('authorization', token).set('tag', 'web').set('ip', this.ipdata?.ip || '');
    return this.http.put(this.commanHost + url, data, { headers });
  }







  getCaptchaKey() {
    // return '6LdwMMgUAAAAAGteaHHXv3OTn8I9nYXO-USZVdbk';
    return '6LexBskUAAAAAEkRpWGzahXA9YUaec_zo865PBQB';
  }

  changeImageToheader(Img): any {
    this.userImage.next(Img);
  }




  FeesFuction(Fees): void {
    this.FeesVal.next(Fees);
  }

  SiteFunction(val): any {
    this.SiteInfo.next(val);
  }

  IpFunction(ip): any {
    this.ipaddress.next(ip);
  }

  postFile(url, fileToUpload, token): Observable<any> {
    const headers = new HttpHeaders().set('token', token);
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    return this.http.post(this.serviceHost + url, formData, { headers });
  }
  initListener() {
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mouseover', () => this.reset());
    document.body.addEventListener('mouseout', () => this.reset());
    document.body.addEventListener('keydown', () => this.reset());
    document.body.addEventListener('keyup', () => this.reset());
    document.body.addEventListener('keypress', () => this.reset());
  }

  reset() {
    this.setLastAction(Date.now());
  }

  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  check() {
    const now = Date.now();
    const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    if (isTimeout) {

      this.socket.offline(this.userid).subscribe(res => {
      });

      localStorage.removeItem("Lkdgisuvaasdjh");
      localStorage.removeItem("UserE-Mail");
      localStorage.removeItem("ASd345634sdg");
      this.router.navigate(['/']);
    }
  }
}

